import { Grid, makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  chipRoot: {
    backgroundColor: theme.palette.gray[800],
    width: "fit-content",
    padding: "0.25rem 0.5rem",
    borderRadius: 90,

    "&.info": {
      backgroundColor: theme.palette.info.main,
    },
    "&.warning": {
      backgroundColor: theme.palette.warning.main,
    },
    "&.danger": {
      backgroundColor: theme.palette.error.main,
    },
    "&.success": {
      backgroundColor: theme.palette.success.main,
    },
  },
  chipLabel: {
    fontSize: "0.75rem",
    color: "#FFFFFF",
    fontWeight: 500,
  },
}));

interface IChipProps {
  className?: string;
  label: string;
  type?: "default" | "info" | "warning" | "danger" | "success";
}

const Chip = ({ className, label, type = "default" }: IChipProps) => {
  const classes = useStyles();
  return (
    <Grid className={clsx(classes.chipRoot, type, className)}>
      <Typography className={classes.chipLabel}>{label}</Typography>
    </Grid>
  );
};

export default Chip;
